import React, { useState } from 'react'
import { FaEye, FaUsers } from 'react-icons/fa';
import SlidingDiv from '../../../components/SlidingDiv';
import { useOutletContext } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useAuth } from '../../../context/auth-context';
import { customStyles } from '../../../styles';
import SupplierStatement from '../suppliers/SupplierStatement';
import CustomerData from '../customers/customerStatement';

export default function Clients() {

    
     const [searchQuery, setSearchQuery] = useState("");
     const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);
      const [title, setTitle] = useState('');
      const [output, setOutput] = useState('');
      const [selectedType, setSelectedType] = useState("");

    const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);


    function viewSupp(id, type, name){

        toggleSlidingDiv()
    
        if(type !=3){
          setTitle('Supplier Statement')
          setOutput(<SupplierStatement id={id} name={name} />)
        }else{
            setTitle('Supplier Statement')
            setOutput(<CustomerData id={id} name={name} />) 
        }
    
      }
   const columns = [
      {
        name: "Sn",
        selector: (row, index) => index + 1,
        width: "50px",
        center: true,
      },
      {
        name: "Names",
        selector: (row) =>`${row.name} ${" "} ${row.person !== null?row.person:''}`,
        sortable: true,
      },
      {
        name: "Contact",
        selector: (row) => row.pnumber,
      },
      {
        name: "Email",
        selector: (row) => row.email,
      },
      {
        name: "Type",
        selector: (row) => row.type==1?'Supplier':row.type==2?'Employee':'Customer',
      },
      {
        name: "Actions",
        cell: (row) => (
          <>

                  <button onClick={()=>viewSupp(row.id, row.type, row.name)} className="bg-blue-950 text-white px-2 py-2 rounded-lg m-2 text-lg"> <FaEye/> </button>
          </>
          
        ),
        button: true,
        center: true,
      },
    ];
     const {allData, setAllData} = useOutletContext();
      const auth = useAuth();
    
      const filteredData = allData.suppliers.filter(supplier => {
        const matchesSearch = supplier.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesType = selectedType === "" || 
          (selectedType == "1" && supplier.type == 1) ||
          (selectedType == "2" && supplier.type == 2) ||
          (selectedType == "3" && supplier.type != 1 && supplier.type != 2);
        
        return matchesSearch && matchesType;
      });
  
    return (
      <div className="w-full flex flex-col bg-white min-h-[400px] rounded-md mt-10 p-5">
        {/* Header */}
        <div className="flex w-full items-center justify-between">
          <h1 className="font-bold text-2xl flex items-center">
                            <FaUsers className="mr-2" /> Clients
                          </h1>
         
        </div>
  
        <hr className="my-3"/>
  
        {/* Supplier Table */}
        <div id="supTable">
         
        <div className="grid grid-cols-2 gap-4 mb-4">
  <input
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={e => setSearchQuery(e.target.value)}
    className="p-2 border border-gray-300 rounded flex-1"
  />
  <select
    value={selectedType}
    onChange={e => setSelectedType(e.target.value)}
    className="p-2 border border-gray-300 rounded"
  >
    <option value="">All</option>
    <option value="1">Supplier</option>
    <option value="2">Employee</option>
    <option value="3">Customer</option>
  </select>
</div>
              
              <br/>
  
              <span className='text-gray-800 pt-5 text-small'>A list of all clients below</span>
  
        <DataTable
                  title=""
                  columns={columns}
                  data={filteredData}
                  pagination
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
              />
  
        </div>
  
  
  
        <SlidingDiv
          isOpen={isSlidingDivOpen}
          onClose={toggleSlidingDiv}
          title={title}
          children = {output}
        /> 
        
       
  
       
      </div>
    );
}
